<template>
  <section>
    <v-card flat>
      <v-container fluid class="pa-0">
        <v-row>
          <v-col cols="12" md="6" offset-md="3">
            <v-row style="margin:0">
              <v-col cols="12">
                <h4 style="margin-top:6px">Tipo</h4>
              </v-col>
              <v-col cols="12">
                <v-select
                  v-model="currentCharge.category_charge"
                  :items="categoryChoices"
                  :error="$v.currentCharge.description.$error"
                  @input="$v.currentCharge.description.$touch()"
                  :error-messages="descriptionErrors"
                  :autofocus="isNewCharge"
                  style="margin-top:0;padding-top:0"
                ></v-select>
              </v-col>

              <v-col cols="12">
                <h4 style="margin-top:6px">Descripción</h4>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="currentCharge.description"
                  :error="$v.currentCharge.description.$error"
                  @input="$v.currentCharge.description.$touch()"
                  :error-messages="descriptionErrors"
                  auto-grow
                  style="margin-top:0;padding-top:0"
                ></v-textarea>
              </v-col>
              <v-col cols="12" style="display:flex;justify-content:center;">
                <v-btn
                  :disabled="requestApprovalDisabled"
                  color="secondary"
                  @click="saveCharge"
                  >GUARDAR COBRO</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </section>
</template>
<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";

import BudgetItemDialog from "./AppBudgetItemDialog";

export default {
  name: "charge-detail",
  components: {
    BudgetItemDialog
  },
  data() {
    return {
      categoryChoices: [
        { text: "Mano de obra", value: 0 },
        { text: "Insumo", value: 1 }
      ],
      techReq: {},
      setTimeout: null,
      budgetItemDialog: false,
      selectedItem: null,
      selectedItemType: null,
      selectedItemIndex: null,
      currentCharge: {
        status_budget: {
          id: 1,
          name: "Nuevo"
        },
        request_technician: null,
        description: "",
        items_manpower: [],
        items_supplies: []
      }
    };
  },
  validations() {
    const validations = {
      currentCharge: {
        description: { required }
      }
    };
    return validations;
  },
  created() {
    this.$store.commit("set_last_screen", "budget-detail");
    this.techReq = this.$store.state.current_techReq;
    if (this.$store.state.current_budget.id)
      this.currentCharge = { ...this.$store.state.current_budget };
  },
  mounted() {
    this.$store.commit("set_app_title", this.dialogTitle);
    window.scrollTo(0, 0);
  },
  computed: {
    isNewCharge: function() {
      if (!this.currentCharge.id) return true;
      return false;
    },
    dialogTitle: function() {
      if (this.currentCharge.id) {
        return "Editar cobro";
      }
      return "Nuevo cobro";
    },
    manpowerTotalAmount: function() {
      let totalAmount = 0;
      this.currentCharge.items_manpower.forEach(item => {
        totalAmount = totalAmount + Number(item.amount) * Number(item.cant);
      });
      return totalAmount;
    },
    suppliesTotalAmount: function() {
      let totalAmount = 0;
      this.currentCharge.items_supplies.forEach(item => {
        totalAmount = totalAmount + Number(item.amount) * Number(item.cant);
      });
      return totalAmount;
    },
    budgetTotalAmount: function() {
      return this.manpowerTotalAmount + this.suppliesTotalAmount;
    },
    addItemsDisabled: function() {
      if (
        !this.currentCharge.id ||
        this.currentCharge.status_budget.id !== 1 ||
        this.$v.currentCharge.$error
      )
        return true;
      return false;
    },
    editChargeDisabled: function() {
      if (this.currentCharge.status_budget.id !== 1) return true;
      return false;
    },
    editItemDisabled: function() {
      if (
        this.currentCharge.status_budget.id !== 1 ||
        this.$v.currentCharge.$error
      )
        return true;
      return false;
    },
    requestApprovalDisabled: function() {
      if (
        !this.currentCharge.id ||
        this.budgetTotalAmount === 0 ||
        this.$v.currentCharge.$error
      )
        return true;
      return false;
    },
    descriptionErrors: function() {
      const errors = [];
      if (!this.$v.currentCharge.description.$error) return errors;
      !this.$v.currentCharge.description.required &&
        errors.push("Este campo es requerido");
      return errors;
    }
  },
  methods: {
    showBudgetItemDialog(itemType, selectedItem, selectedItemIndex) {
      if (!this.editChargeDisabled && !this.editItemDisabled) {
        selectedItem
          ? (this.selectedItem = selectedItem)
          : (this.selectedItem = { description: null, cant: 1, amount: null });
        this.selectedItemIndex = selectedItemIndex;
        this.selectedItemType = itemType;
        this.budgetItemDialog = true;
      }
    },
    deleteItem() {
      switch (this.selectedItemType) {
        case "manpower":
          this.currentCharge.items_manpower.splice(this.selectedItemIndex, 1);
          break;
        case "supplies":
          this.currentCharge.items_supplies.splice(this.selectedItemIndex, 1);
          break;
      }
      this.saveCharge();
    },
    saveItem(item) {
      if (!this.selectedItemIndex) {
        switch (this.selectedItemType) {
          case "manpower":
            this.currentCharge.items_manpower.push(item);
            break;
          case "supplies":
            this.currentCharge.items_supplies.push(item);
            break;
        }
      } else {
        switch (this.selectedItemType) {
          case "manpower":
            this.currentCharge.items_manpower[this.selectedItemIndex] = item;
            break;
          case "supplies":
            this.currentCharge.items_supplies[this.selectedItemIndex] = item;
            break;
        }
      }
      this.saveCharge();
    },
    saveCharge() {
      this.$v.currentCharge.$touch();
      if (!this.$v.currentCharge.$error) {
        if (!this.currentCharge.id) {
          this.currentCharge.request_technician = this.techReq.id;
          this.axios
            .post("/budget/", this.currentCharge)
            .then(response => {
              this.currentCharge = response.data;
              this.$store.commit(
                "show_alert",
                "Cambios guardados correctamente"
              );
              this.$store.commit("set_current_budget", this.currentCharge);
            })
            .catch(err => {
              alert(err);
            });
        } else {
          this.axios
            .put(`/budget/${this.currentCharge.id}/`, this.currentCharge)
            .then(response => {
              this.currentCharge = response.data;
              this.$store.commit(
                "show_alert",
                "Cambios guardados correctamente"
              );
              this.$store.commit("set_current_budget", this.currentCharge);
            })
            .catch(err => {
              alert(err);
            });
        }
      }
    },
    requestApproval() {
      this.axios
        .post(`/budget/${this.currentCharge.id}/send/`, {})
        .then(response => {
          Object.assign(
            this.currentCharge.status_budget,
            response.data.status_budget
          );
          this.$store.commit("show_alert", "Cambios guardados correctamente");
          this.$store.commit("set_current_budget", this.currentCharge);
        })
        .catch(err => {
          alert(err);
        });
    },
    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    }
  }
};
</script>
<style scoped>
@media (min-width: 960px) {
  .pull-right-on-desktop {
    display: flex;
    justify-content: flex-end;
  }
}
.bottom-bar {
  position: fixed;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 88px;
  display: flex;
  justify-content: flex-end;
}
.pb24 {
  padding-bottom: 84px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.date {
  text-transform: capitalize;
  text-align: left;
}
.status-name-cont {
  height: 30px;
  background: #c8272a;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
  text-transform: capitalize;
}
</style>
